"use client";

import type { VariantProps } from "class-variance-authority";

import { FeatureIcon, type FeatureIconProps } from "../../components";
import { cn } from "../../utils";
import { useEmptyStateRootContext } from "./context";
import { illustrationIconStyle } from "./style";

export type EmptyStateIllustrationIconProps = Pick<FeatureIconProps, "children" | "className"> &
  VariantProps<typeof illustrationIconStyle>;

const IllustrationIcon = ({ children, color, className }: EmptyStateIllustrationIconProps) => {
  const { size } = useEmptyStateRootContext();

  const CORRESPONDING_FEATURE_ICON_SIZE_MAP = {
    sm: "lg",
    md: "xl",
    lg: "xl",
  };

  return (
    <FeatureIcon
      variant="light-circle-primary"
      className={cn(illustrationIconStyle({ color }), className)}
      size={CORRESPONDING_FEATURE_ICON_SIZE_MAP[size || "sm"] as FeatureIconProps["size"]}
    >
      {children}
    </FeatureIcon>
  );
};

export default IllustrationIcon;
